import { MutationHookOptions, useMutation } from "@apollo/client";

import { AiIntegration, MutationAiIntegrationUpdateArgs } from "types/generated";

import { UPDATE_AI_INTEGRATION } from "./gql";

type UseUpdateAiIntegrationOptions = Omit<
  MutationHookOptions<
    { aiIntegrationUpdate: Pick<AiIntegration, "id"> },
    MutationAiIntegrationUpdateArgs
  >,
  "variables"
>;

const useUpdateAiIntegration = (options?: UseUpdateAiIntegrationOptions) => {
  return useMutation(UPDATE_AI_INTEGRATION, {
    awaitRefetchQueries: true,
    ...options,
  });
};

export default useUpdateAiIntegration;
